<script setup lang="ts">
    const modelValue = defineModel();
    const props = defineProps({
        label: {
            type: String,
            default: ""
        },
        labelClasses: {
            type: String,
            default: ""
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
    });
</script>
<template>
    <component :style="{
        cursor: disabled ? 'not-allowed' : 'pointer',
    }" :is="label !== null ? 'label' : 'span'" class="checkbox" style="width: fit-content;">
        <input type="checkbox" :checked="modelValue" @change="$emit('update:modelValue', $event.target.checked ? 1 : 0)"  :aria-label="label" :disabled="disabled" />
        <span :class="labelClasses" v-if="label">{{ label }}</span>
    </component>
</template>
